module.exports = __webpack_public_path__ + "img/ellipse.f19883c9.svg";